import type { FlowNodeResultADT } from '@lighthouse/shared'
import { scroll2FlowNode } from '@lighthouse/shared'

import type { ExecuteActionParams } from '../type'

type ScrollToConfig = { scrollToElementId?: string }

const scrollToCore = (config: ScrollToConfig | undefined, scope?: string) => {
    const { scrollToElementId } = config || {}
    if (scrollToElementId) {
        scroll2FlowNode(scrollToElementId, scope)
    }
    return {
        type: 'record',
        success: true
    } as FlowNodeResultADT
}

// list 独立动作使用
export const handleScrollToList = (config: ScrollToConfig, _params: ExecuteActionParams): Promise<FlowNodeResultADT> => {
    const { scope } = _params
    // const config = node.data?.config || node.data
    return Promise.resolve(scrollToCore(config, scope))
}
